import React, { useState, useEffect } from 'react'
import { View } from 'react-native'
// import { CommonActions } from '@react-navigation/native'
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs'
import { useDispatch, useSelector } from 'react-redux'

import ActionCreators from '../store/actions'
import * as colors from '../config/colors'
import HGIcon from '../components/HGIcon'
import patientGroups from '../config/patientGroups'

import Start from './StartNavigator'
import Documentation from './DocumentationNavigator'
import Info from './InfoNavigator'
import News from './NewsNavigator'
import Settings from './SettingsNavigator'
import { commonScreenOptions } from '../config/navigation'

// const pushNavigation = (route: string) => {
//   return CommonActions.navigate({ name: route })
// }

// const resetNavigation = (route: string) => {
//   return CommonActions.reset({
//     index: 0,
//     routes: [{ name: route }],
//   })
// }

// const tabNavigatorOptions = {
//   lazy: true,
//   initialRouteName: 'Start',
//   tabBarPosition: 'bottom',
//   tabBarOptions: {
//     showLabel: true,
//     showIcon: true,
//     activeTintColor: colors.blue,
//   },
//   tabBarComponent: (props) => {
//     const { navigation, navigationState } = props
//     const jumpToIndex = (index) => {
//       const lastPosition = navigationState.index
//       const tab = navigationState.routes[index]
//       const tabRoute = tab.routeName
//       const firstTab = tab.routes[0].routeName

//       lastPosition !== index && navigation.dispatch(pushNavigation(tabRoute))
//       lastPosition === index && navigation.dispatch(resetNavigation(firstTab))
//     }
//     return <BottomTabBar {...props} jumpToIndex={jumpToIndex} />
//   },
// }

const TabBarIcon = (props: {
  name: string
  tintColor: string
  size?: number
}) => {
  const { name, tintColor, size = 25 } = props

  return (
    <View>
      <HGIcon
        name={name} // documentation
        size={size}
        color={tintColor}
      />
    </View>
  )
}

const Tab = createBottomTabNavigator()

const SignedInNavigator = ({ startTabTitle }: { startTabTitle?: string }) => {
  return (
    <Tab.Navigator
      initialRouteName="Start"
      screenOptions={{ ...commonScreenOptions }}
    >
      <Tab.Screen
        name="Start"
        component={Start}
        options={{
          tabBarIcon: ({ focused, color }) => (
            <TabBarIcon name="children" tintColor={color} />
          ),
          title: startTabTitle || 'Start',
        }}
      />
      <Tab.Screen
        name="Info"
        component={Info}
        options={{
          tabBarIcon: ({ focused, color }) => (
            <TabBarIcon name="bookmark" tintColor={color} />
          ),
          title: 'Info',
        }}
      />
      <Tab.Screen
        name="Documentation"
        component={Documentation}
        options={{
          tabBarIcon: ({ focused, color }) => (
            <TabBarIcon name="doku" tintColor={color} />
          ),
          title: 'Dokumentation',
        }}
      />
      <Tab.Screen
        name="News"
        component={News}
        options={{
          tabBarIcon: ({ focused, color }) => (
            <TabBarIcon name="speechbubble" tintColor={color} />
          ),
          title: 'Neues',
        }}
      />
      <Tab.Screen
        name="Settings"
        component={Settings}
        options={{
          tabBarIcon: ({ focused, color }) => (
            <TabBarIcon name="profile" tintColor={color} />
          ),
          // title: 'Einstellungen',
        }}
      />
    </Tab.Navigator>
  )
}

const SignedIn = () => {
  const { patientGroup } = useSelector((state) => state.user)
  const [startTabTitle, setStartTabTitle] = useState('Start')
  const dispatch = useDispatch()

  // const { user, togglePatientGroupModal } = this.props
  useEffect(() => {
    if (patientGroup === null) {
      dispatch(ActionCreators.togglePatientGroupModal({ toggle: true }))
    }

    const patientGroupData = patientGroups.find((i) => i.id === patientGroup)
    const patientGroupDisplayName = patientGroupData
      ? patientGroupData.label
      : ''
    setStartTabTitle(patientGroupDisplayName)
  }, [])

  // console.log('SignedIn:', loggedIn)

  return <SignedInNavigator startTabTitle={startTabTitle} />
}

export default SignedIn
